import React, { useState, useEffect, useRef, Fragment } from 'react';
import { IconButton, useMediaQuery, CircularProgress, Stack, Skeleton } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import debounce from 'lodash/debounce';
import ItemList from 'app/components/ItemList';
import Icon from 'app/components/Icon';
import Avatar from 'app/components/Avatar';
import { useNavigate } from 'react-router-dom';

const UserItem = styled(Stack)(({ theme, ld }) => ({
    padding:'10px 12px 8px',
    background:"#FFF",
    gap:"12px",
    border:"0",
    borderBottom:`1px solid #eee`,
    '& .pht': {
        cursor:"pointer",
        width:'40px',
        height:'40px',
        padding:'1px',
        border:"1px solid #ddd",
        borderRadius:"50%",
        display:"flex",
    },
    '& .dtl': { display:"flex", flex:"1" , flexDirection:"column",  width:"calc(100% - 70px)",  justifyContent: 'center',
        '& a':{ marginBottom: ld ? "3px" : '2px', textDecoration:"none", fontSize:"13px", fontWeight:"bold", lineHeight: '16px', overflow:"hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%', display: 'block', },
        '& .ln': { margin:0, overflow:"hidden", fontSize:"12.1px", whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%', display: ld ? "flex" : 'block', gap:"4px", lineHeight:"18px", paddingTop: ld ? "5px" : 0,
            '& .fa': { textAlign:"center", fontSize: '14px', width:"14px", marginRight:"2px" },
        },
        '& .dot': { display: 'inline-flex', background: '#888', width: '4px',height: '4px',borderRadius: '50%', margin: '-1px 7px 0 7px' },
      '& .MuiSkeleton-root':{ borderRadius:"5px"}
    },
}));

const SearchBox = () => {

  const theme = useTheme(); 
  const ref= useRef();   
  const isMb = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(!isMb);
  const toggle=()=>{ setOpen(!open); if(open) close() };
  const [searching,setSearching] = useState(false);
  const [text,setText] = useState('');
  const [showRsl,setShowRsl] = useState(false);
  const [reload,setReload] = useState(false);
  const navigate = useNavigate();
  
  useEffect(()=>{ 
      if(isMb) close();
      else setOpen(true); 
      return ()=>close();
  },[isMb]);

  useEffect(()=>{
      if( (text || '').length <= 2)
        setShowRsl(false);
  },[text]);

  const onChange = debounce(function(e){
      let _txt = e.target.value || '';
      setText(_txt);
      _txt = _txt.trim();
      setSearching(_txt.length > 2);
      if( _txt.length > 2 ){
          setShowRsl(true);
          setReload(false);
          setTimeout(()=>setReload(true),0);
          /*
        setTimeout(()=>{
          setSearching(false);
        },900);
        */
      }
  }, 700);
  
  const close = () => {
    if(isMb) setOpen(false);
    setText('');
    setSearching(false);
    setShowRsl(false);
    if( ref && ref.current ) ref.current.value = '';
  }

  const renderUserItem = (item,idx, ld = 0) => {
    if( !ld && !item?.username ) return false;
    
    return (
        <UserItem className={`item${ld ? ' ld' :''}`} direction="row" ld={ld}>
          <div className="pht">
            {ld ? <Skeleton variant="circular" width={36} height={36}/>
            :<Avatar size={36} name={`${item.firstname} ${item.lastname}`} url={item.image} onClick={()=>{ close(false); navigate(`/user/${item.username}`,{ state:item}); }} />}
          </div>
          <div className="dtl">
            {ld ? <Skeleton variant="rounded" width={130} height={16} style={{ marginTop:"2px" }}/> :
            <a href={`/user/${item.username}`} onClick={(e)=>{ e.preventDefault(); close(false); navigate(`/user/${item.username}`,{ state:item}) }}>{item.firstname} {item.lastname}</a>}

            <p className="ln">
                {ld ? <Fragment>
                  <Skeleton variant="rounded" width={13} height={13} />
                  <Skeleton variant="rounded" width={40} height={13} />
                  <Skeleton variant="rounded" width={30} height={13} />
                  <Skeleton variant="rounded" width={70} height={13} />
                </Fragment> : <Fragment>
                  <Icon className="gender">{item.gender === 'F' ? 'female' : 'male'}</Icon>
                  {item.extra?.gender || "Male"} 
                  <span className="dot"></span>
                  {item.extra?.age} 
                  <span className="dot"></span>
                  {item?.extra.relationship_status}
                </Fragment>}
            </p>
            {(ld || item?.extra?.location) && <p className="ln">
              {ld ? <Fragment>
                <Skeleton variant="rounded" width={13} height={13} />
                <Skeleton variant="rounded" width={140} height={13} />
              </Fragment> : <Fragment>
                <Icon>map-marker</Icon>{item.extra?.location || null}
              </Fragment>}
            </p>}
          </div>
        </UserItem>
      );
  }

  return (
    <React.Fragment>
      {(isMb) && (
        <IconButton className="btn-search" onClick={toggle}>
          <Icon size={17}>search</Icon>
        </IconButton>
      )}

      {showRsl && reload && <div className="search-overlay" onClick={()=>close()}></div>}

      {open && (
        <div className={`search-box${isMb ? ' mb' : ''}`}>
            <Icon size={15}>search</Icon>
            <input className="fld" type="text" ref={ref} maxLength="40" placeholder="Search anything..." onChange={onChange} autoFocus={open && isMb} />
            {searching && <CircularProgress size={22} color="inherit" />}
            {(isMb || showRsl) && <IconButton onClick={()=>close()} sx={{verticalAlign:'middle'}}>
              <Icon size={18} style={{color:"#666"}}>times</Icon>
            </IconButton>}

            {showRsl && reload && <div className="items">
              <ItemList 
                url={`user/list?q=${encodeURI(text)}`}
                emptyText={`No user found for '${text}'`} 
                errorMargin={15}
                columns={1}
                spacing={0}
              //  skeleton={()=><div></div>}
                //hideLoading={hideLoading}
                boxPadding={0}
                limit={20}
                maxHeight={isMb ? 'calc(100vh - 100px)' : "300px"}
                onLoading={(laoding)=>setSearching(laoding)}
                renderItem={(item,i)=>renderUserItem(item,i,0)}
                skeleton={(item,i)=>renderUserItem(item,i,1)}
              />
            </div>}
        </div>
      )}
    </React.Fragment>
  );
};

export default SearchBox;
